const routes = [
  {
    path: 'aggridencapsulation',
    name: 'aggridencapsulation',
    component: () => import(/* webpackChunkName: "aggridencapsulation" */ '@/modules/aggridencapsulation/index.vue')
  },
];

export default routes;